import BankAccountsManager from '../../bank/BankAccountsManager';
import { Card } from '../../new-components/ui/card';

/**
 * Bank Accounts — thin wrapper around BankAccountsManager so it's a self-contained section
 * like the others. Extracted verbatim from AccountSettings (no behavior change).
 */
export function BankSection() {
  return (
    <Card className="p-6 border-border">
      <BankAccountsManager />
    </Card>
  );
}

export default BankSection;
